/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IMapHierarchyItem, IPlaceCategory, IReverseGeocodeResponse } from '../../../core/models';
import { CloseSidePanel } from '../../../core/store/actions';
import { getIsMandatoryGeofenceGroupsFeatureEnabled, getMapHierarchyGroups } from '../../../core/store/selectors';
import { IAppState } from '../../../core/store/state';
import { IGeofenceFormData, IPlace } from '../../models';
import { getGeofenceAddress, getPlaceBalloon, getPlaceDropdownCategories, ResetGeofenceState, SaveGeofence } from '../../store';

@Component({
  selector: 'fm-geofence-form-container',
  templateUrl: './geofence-form-container.component.html',
  styleUrls: ['./geofence-form-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeofenceFormContainerComponent implements OnInit, OnDestroy {
  public geoFenceAddress$: Observable<IReverseGeocodeResponse>;
  public placeCategories$: Observable<IPlaceCategory[]>;
  public hierarchyGroups$: Observable<IMapHierarchyItem[]>;
  public mandatoryGeofenceGroupsEnabled$: Observable<boolean>;
  public placeLoaded$: Observable<IPlace>;

  constructor(private readonly _store: Store<IAppState>) {}

  ngOnInit(): void {
    this.geoFenceAddress$ = this._store.pipe(select(getGeofenceAddress));
    this.placeCategories$ = this._store.pipe(select(getPlaceDropdownCategories));
    this.hierarchyGroups$ = this._store.pipe(
      select(getMapHierarchyGroups),
      map(groups => groups.filter(group => group?.level > 0)) // Filter entire fleet
    );
    this.mandatoryGeofenceGroupsEnabled$ = this._store.pipe(select(getIsMandatoryGeofenceGroupsFeatureEnabled));
    this.placeLoaded$ = this._store.pipe(select(getPlaceBalloon));
  }

  ngOnDestroy(): void {
    this._store.dispatch(new ResetGeofenceState());
  }

  public saveGeofence(formData: IGeofenceFormData): void {
    this._store.dispatch(new SaveGeofence(formData));
  }

  public closeGeofencePanel(): void {
    this._store.dispatch(new ResetGeofenceState());
    this._store.dispatch(new CloseSidePanel());
  }
}
